import { Pipe, PipeTransform } from '@angular/core';
import {ProblemType, ProblemTypesMap} from '@app/views/dashboard/dashboard.model';

@Pipe({
    name: 'problemTypesFriendlyName'
})
export class ProblemTypesFriendlyNamePipe implements PipeTransform {

    transform(value: ProblemType, args?: any): any {
        if (ProblemTypesMap.has(value)) {
            return ProblemTypesMap.get(value);
        } else {
            return value ? value.replace(/[_-]/g, ' ') : '';
        }
    }
}
